import { render, staticRenderFns } from "./LocationModal.vue?vue&type=template&id=a4044b08&scoped=true&"
import script from "./LocationModal.vue?vue&type=script&lang=ts&"
export * from "./LocationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4044b08",
  null
  
)

export default component.exports